const DISCOVERY_LIST_PAGE_SIZE = 25;
const DISCOVERY_LIST_INITIAL_PAGE = 1;
const DATE_TIME_FORMAT = 'MM/DD/YY h:mm a';

export { DISCOVERY_LIST_PAGE_SIZE, DISCOVERY_LIST_INITIAL_PAGE, DATE_TIME_FORMAT };